import { useStore } from 'hooks/useRootStore';
import { observer } from 'mobx-react-lite';
import { useMyTranslations } from 'hooks/useMyTranslations';
import { confirmPopupTranslations } from './translations';
import { ConfirmPopupTransFields } from './types';
import styles from './confirmationForm.module.scss';
import { useCallback } from 'react';
import { useThrottleFn } from 'hooks/useThrottleFn';

export const ConfirmationForm = observer(function () {
  const {
    popUpStore: { title, description, buttonLabel, closePopUp, callBack },
  } = useStore();

  const { t } = useMyTranslations<ConfirmPopupTransFields>([confirmPopupTranslations.name]);

  const handleSave = useThrottleFn(
    useCallback(() => {
      callBack && callBack.cb();
    }, [callBack])
  );

  return (
    <form className={styles.form}>
      <p className={styles.title}>{title}</p>
      <p className={styles.desc}>{description}</p>
      <footer className={styles.footer}>
        <button type='reset' className={styles.btnReset} onClick={closePopUp}>
          {t('cancel')}
        </button>
        <button type='button' className={styles.btnSubmit} onClick={handleSave}>
          {buttonLabel}
        </button>
      </footer>
    </form>
  );
});
